import { baseRoute } from '../../constants/routes';
export const APPEARENCE_ROUTE = baseRoute + '/appearance';
export const CREATE_THEME = 'CREATE_THEME';
export const CREATE_THEME_IN_QUIZ_SUCCESS = 'CREATE_THEME_IN_QUIZ_SUCCESS';
export const CREATE_THEME_IN_CALENDAR_SUCCESS = 'CREATE_THEME_IN_CALENDAR_SUCCESS';
export const UPDATE_THEME = 'UPDATE_THEME';
export const UPDATE_THEME_IN_QUIZ_SUCCESS = 'UPDATE_THEME_IN_QUIZ_SUCCESS';
export const UPDATE_THEME_IN_CALENDAR_SUCCESS = 'UPDATE_THEME_IN_CALENDAR_SUCCESS';
export const DELETE_THEME = 'DELETE_THEME';
export const DELETE_THEME_IN_QUIZ_SUCCESS = 'DELETE_THEME_IN_QUIZ_SUCCESS';
export const DELETE_THEME_IN_CALENDAR_SUCCESS = 'DELETE_THEME_IN_CALENDAR_SUCCESS';